
import React from "react";
import { useNavigate } from "react-router-dom";
import "./PromotionsPage.css";

const PromotionsPage = () => {
  const navigate = useNavigate();

  const promos = [
    {
      id: 1,
      icon: "🎁",
      tag: "FIRST DEPOSIT",
      title: "Bonus ya Amana ya Kwanza",
      currency: "TZS",
      rate: "10%",
      minimum: "10,000 TZS",
      desc:
        "Weka amana yako ya kwanza na upate bonus ya 10% kwenye TZS balance yako.",
      example:
        "Mfano: 100,000 TZS → 10,000 TZS Bonus",
      route: "/FirstDepositBonus",
      active: true,
      type: "primary",
    },

    {
      id: 2,
      icon: "💵",
      tag: "FIRST DEPOSIT",
      title: "Bonus ya Amana ya Kwanza",
      currency: "USDT",
      rate: "BONUS",
      minimum: "—",
      desc:
        "Fungua nafasi ya bonus kwa deposit yako ya kwanza kupitia USDT.",
      example:
        "Bonus itahesabiwa kulingana na promotion ya USDT.",
      route: "/FirstDepositBonusUSDT",
      active: true,
      type: "blue",
    },

    {
      id: 3,
      icon: "📅",
      tag: "WEDNESDAY",
      title: "Weekly Deposit Bonus",
      currency: "TZS",
      rate: "2.5%",
      minimum: "Wednesday",
      desc:
        "Fanya deposit inayostahili siku ya Jumatano na upate Weekly Deposit Bonus ya 2.5%.",
      example:
        "Mfano: 1,000,000 TZS → 25,000 TZS Bonus",
      route: "/WeeklyDepositBonus",
      active: true,
      type: "orange",
    },

    {
      id: 4,
      icon: "🎯",
      tag: "SECOND DEPOSIT",
      title: "Bonus ya Amana ya Pili",
      currency: "TZS",
      rate: "5% – 8%",
      minimum: "300,000 TZS",
      desc:
        "Deposit yako ya pili inaweza kupata bonus kulingana na kiwango cha deposit.",
      example:
        "300K–499K: 5% • 500K–999K: 6% • 1M–2.99M: 7% • 3M–4.99M: 8%",
      route: "/SecondDepositBonus",
      active: true,
      type: "purple",
    },

    {
      id: 5,
      icon: "💎",
      tag: "SECOND DEPOSIT",
      title: "Bonus ya Amana ya Pili",
      currency: "USDT",
      rate: "BONUS",
      minimum: "—",
      desc:
        "Pata bonus maalum kwa deposit yako ya pili kupitia USDT.",
      example:
        "Bonus itahesabiwa kulingana na promotion ya USDT.",
      route: "/SecondDepositBonusUSDT",
      active: true,
      type: "cyan",
    },
  ];

  const applyBonus = (promo) => {
    if (!promo.active) return;
    navigate(promo.route);
  };

  return (
    <div className="promo-page">

      {/* =================================================
          BACKGROUND
      ================================================= */}

      <div className="promo-orb promo-orb-one" />
      <div className="promo-orb promo-orb-two" />


      {/* =================================================
          HEADER
      ================================================= */}

      <header className="promo-header">

        <div className="promo-top-badge">
          <span>✦</span>
          BONUS CENTER
        </div>

        <h1>
          Promotions
          <span> & Bonuses</span>
        </h1>

        <p>
          Chagua promotion inayokufaa na
          <strong> chukua bonus yako </strong>
          kulingana na masharti ya deposit.
        </p>

      </header>


      {/* =================================================
          STATS
      ================================================= */}

      <div className="promo-stats">

        <div className="promo-stat">
          <span className="promo-stat-icon">🎁</span>

          <div>
            <strong>5</strong>
            <small>Promotions</small>
          </div>
        </div>


        <div className="promo-stat">
          <span className="promo-stat-icon">💰</span>

          <div>
            <strong>TZS</strong>
            <small>Deposit Bonus</small>
          </div>
        </div>


        <div className="promo-stat">
          <span className="promo-stat-icon">📅</span>

          <div>
            <strong>2.5%</strong>
            <small>Weekly Bonus</small>
          </div>
        </div>


        <div className="promo-stat">
          <span className="promo-stat-icon">⚡</span>

          <div>
            <strong>LIVE</strong>
            <small>Promotions</small>
          </div>
        </div>

      </div>


      {/* =================================================
          INFO BANNER
      ================================================= */}

      <div className="promo-info">

        <div className="promo-info-icon">
          💡
        </div>

        <div>
          <strong>
            Jinsi Bonus Zinavyofanya Kazi
          </strong>

          <p>
            Kila promotion ina masharti yake.
            Hakikisha deposit yako imekamilika na
            iko katika status ya <b>Success</b> kabla
            ya kudai bonus.
          </p>
        </div>

      </div>


      {/* =================================================
          PROMOTIONS
      ================================================= */}

      <section className="promo-section">

        <div className="promo-section-title">

          <div>
            <span>AVAILABLE OFFERS</span>
            <h2>
              Chagua Bonus Yako
            </h2>
          </div>

          <div className="promo-live">
            <i />
            LIVE
          </div>

        </div>


        <div className="promo-grid">

          {promos.map((promo) => (

            <article
              className={`promo-card promo-${promo.type}`}
              key={promo.id}
            >

              {/* CARD TOP */}

              <div className="promo-card-top">

                <div className="promo-icon">
                  {promo.icon}
                </div>

                <div className="promo-tag">
                  {promo.tag}
                </div>

              </div>


              {/* TITLE */}

              <h3>
                {promo.title}
              </h3>


              <div className="promo-currency">
                <span>
                  {promo.currency}
                </span>

                <strong>
                  {promo.rate}
                </strong>
              </div>


              {/* DESCRIPTION */}

              <p className="promo-desc">
                {promo.desc}
              </p>


              {/* DETAILS */}

              <div className="promo-details">

                <div>
                  <span>
                    Minimum
                  </span>

                  <strong>
                    {promo.minimum}
                  </strong>
                </div>


                <div>
                  <span>
                    Status
                  </span>

                  <strong className="promo-status">
                    <i />
                    Available
                  </strong>
                </div>

              </div>


              {/* EXAMPLE */}

              <div className="promo-example">

                <span>
                  CALCULATION
                </span>

                <p>
                  {promo.example}
                </p>

              </div>


              {/* BUTTON */}

              <button
                type="button"
                className="promo-button"
                onClick={() => applyBonus(promo)}
                disabled={!promo.active}
              >

                <span>
                  {promo.active
                    ? "Chukua Bonus"
                    : "Coming Soon"}
                </span>

                {promo.active && (
                  <b>→</b>
                )}

              </button>

            </article>

          ))}

        </div>

      </section>


      {/* =================================================
          SECOND DEPOSIT TABLE
      ================================================= */}

      <section className="promo-rates">

        <div className="promo-rates-heading">

          <span>
            SECOND DEPOSIT
          </span>

          <h2>
            TZS Bonus Levels
          </h2>

          <p>
            Kiwango cha bonus kinaongezeka
            kulingana na kiasi cha second deposit.
          </p>

        </div>


        <div className="promo-rate-list">

          <div className="promo-rate-row">
            <span>300,000 – 499,999</span>
            <strong>5%</strong>
          </div>

          <div className="promo-rate-row">
            <span>500,000 – 999,999</span>
            <strong>6%</strong>
          </div>

          <div className="promo-rate-row">
            <span>1,000,000 – 2,999,999</span>
            <strong>7%</strong>
          </div>

          <div className="promo-rate-row">
            <span>3,000,000 – 4,999,999</span>
            <strong>8%</strong>
          </div>

          <div className="promo-rate-row promo-rate-special">
            <span>5,000,000+</span>
            <strong>500,000 TZS</strong>
          </div>

        </div>

      </section>


      {/* =================================================
          WEEKLY INFO
      ================================================= */}

      <section className="promo-weekly">

        <div className="promo-weekly-icon">
          📅
        </div>

        <div className="promo-weekly-content">

          <span>
            EVERY WEDNESDAY
          </span>

          <h2>
            Weekly Deposit Bonus
          </h2>

          <p>
            Deposit inayostahili siku ya Jumatano
            inaweza kupata bonus ya
            <strong> 2.5% </strong>
            kwenye TZS balance yako.
          </p>

        </div>

        <div className="promo-weekly-rate">
          <strong>
            2.5%
          </strong>

          <span>
            BONUS
          </span>
        </div>

      </section>


      {/* =================================================
          FOOTER NOTE
      ================================================= */}

      <div className="promo-footer">

        <span>
          🔒
        </span>

        <p>
          Bonus inaweza kudaiwa mara moja tu
          kwa promotion inayostahili. Mfumo
          utakagua deposit yako kabla ya
          kuidhinisha bonus.
        </p>

      </div>

    </div>
  );
};

export default PromotionsPage;


